module.exports = __webpack_public_path__ + "img/label_orange.824dc1c3.png";